import basicController from "servicestack/basic.controller.properties";
import authConfig from "emun.auth/auth.config"; //get shared
import ServiceBus from 'servicestack/service-bus'

export default class AcceptTermsPromptController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = authConfig;
		$ctrl.bus = new ServiceBus();
	}
	submit() {
		const $ctrl = this;
		$ctrl.bus.send("AcceptVendorTerms.json", { VendorId: $ctrl.$session.retailerId }).then(res => {
			$ctrl.$session.$broadcast("$vendorAcceptedTerms");
			$ctrl.$close(res);
		});
	}
}